const NUMBER_FORMATTER = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

export function normalizeFieldType(type) {
  return String(type || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
}

export function isSquareFootageType(type) {
  return normalizeFieldType(type) === "squarefootage";
}

export function parseSquareFootageValue(value) {
  if (value === null || value === undefined) return null;

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === "string") {
    const cleaned = value.replace(/,/g, "").trim();
    if (!cleaned) return null;
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}

export function formatFieldValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Included" : "Not Included";
  if (Array.isArray(value)) {
    if (value.length === 0) return "-";
    return value.map((item) => String(item)).join(", ");
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch (err) {
      return String(value);
    }
  }
  return String(value);
}

export function formatSquareFootageNumber(value) {
  const parsed = parseSquareFootageValue(value);
  return parsed === null ? null : NUMBER_FORMATTER.format(parsed);
}

export function isPdfAssetUrl(url) {
  return /\.pdf([?#].*)?$/i.test(String(url || "").trim());
}

export function buildPdfEmbedUrl(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  const hasHash = raw.includes("#");
  return `${raw}${hasHash ? "&" : "#"}toolbar=0&navpanes=0&scrollbar=0`;
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
}

export function isValidPhone(phone) {
  return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone);
}

export function formatNumber(value) {
  return NUMBER_FORMATTER.format(value);
}

function getFieldDisplayOrder(fieldValue, fallbackValue) {
  const parsed = Number(fieldValue?.fieldId?.displayOrder);
  return Number.isFinite(parsed) ? parsed : fallbackValue;
}

export function sortFieldValuesForDisplay(fieldValues) {
  return (Array.isArray(fieldValues) ? fieldValues : [])
    .map((fieldValue, index) => ({ fieldValue, index }))
    .sort((a, b) => {
      const orderDelta =
        getFieldDisplayOrder(a.fieldValue, a.index) -
        getFieldDisplayOrder(b.fieldValue, b.index);
      if (orderDelta !== 0) return orderDelta;

      return String(a.fieldValue?.fieldId?.name || "").localeCompare(
        String(b.fieldValue?.fieldId?.name || "")
      );
    })
    .map((item) => item.fieldValue);
}
